import {Injectable} from '@angular/core';
import {HttpService} from '../../../common/api/http.service';
import {Observable} from 'rxjs';
import {DGAConcentration, LatestGasReading, DGADuvalPentagonData, GasSummary} from '@core/interfaces/live/online-dga';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {LatestModelStatus} from '@core/interfaces/live/live';
import {HttpParams} from '@angular/common/http';
import {APIResponse, Filter} from '@core/interfaces/system/system-common';
import {map} from 'rxjs/operators';

@Injectable()
export class OnlineDgaApi {
    private readonly PREFIX = 'live/output/online-dga';

    constructor(private api: HttpService) {}

    public getOnlineDgaDatasource(id: string, filters: Filter[]): Observable<DataSource> {
        return this.api.postServerDataSource(`${this.PREFIX}/list?filterByassetId=${id}`, filters);
    }

    public getCountResults(assetId: string, uploadTime?: string): Observable<number> {
        return this.api
            .get(`${this.PREFIX}/count`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<number>) => res.response));
    }

    public getOnlineDgaLatestModelStatus(id: string, uploadTime?: string): Observable<LatestModelStatus> {
        return this.api
            .get(`${this.PREFIX}/latest`, {
                params: new HttpParams().set('assetId', id || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<LatestModelStatus>) => res.response));
    }

    public getLatestGasReading(id: string, uploadTime: string): Observable<LatestGasReading> {
        return this.api
            .get(`${this.PREFIX}/latest-gas-reading`, {
                params: new HttpParams().set('assetId', id || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<LatestGasReading>) => res.response));
    }

    public getModelDashboardDuvalPentagon(id: string, uploadTime?: string): Observable<DGADuvalPentagonData> {
        return this.api
            .get(`${this.PREFIX}/data/duval-pentagon`, {
                params: new HttpParams().set('assetId', id || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<DGADuvalPentagonData>) => res.response));
    }

    public getModelDashboardGasSummary(id: string, uploadTime?: string): Observable<GasSummary> {
        return this.api
            .get(`${this.PREFIX}/data/gas-summary`, {
                params: new HttpParams().set('assetId', id || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<GasSummary>) => res.response));
    }

    public getGasConcentration(id: string, gas: string, uploadTime: string): Observable<DGAConcentration> {
        return this.api
            .get(`${this.PREFIX}/data/gas-concentration`, {
                params: new HttpParams()
                    .set('assetId', id || '')
                    .set('asOf', uploadTime || '')
                    .set('gas', gas || 'oxygen'),
            })
            .pipe(map((res: APIResponse<DGAConcentration>) => res.response));
    }
}
